<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";
import Swal from "sweetalert2";

import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import {getBaseUrl} from "@/helpers/baseUrl";



export default {


  components: { Layout, PageHeader, DxButton,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations,
    Loader

  },
  data() {

    return {
      title: "Inventários",
      items: [
        {
          text: "Estoque",
          href: "/"
        },
        {
          text: "Inventários",
          active: true
        }
      ],
      dataList: null,
      totalList: 0,
      updating: false,
      exibEmit: true,
      exibDest: false,
      exibAmbos: false,

    };
  },

  created() {

  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted mov-list_0')
    this.atualizaDataList()
  },

  methods: {

    carregouGrid(e){
      console.log('carregouGrid')
      this.title = '(' + e.component.totalCount() + ') Inventários'
    },


    atualizaDataList(){
      console.log('atualizaDataList_mov')
      console.log(this.exibEmit)


      this.dataList = new CustomStore({
        key: "movinvent_id",
        load: function(loadOptions){


          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
          }

          console.log('paramsReq')
          console.log(paramsReq)

          return api.get(`${getBaseUrl()}api/movinvents`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data')
            console.log(response)
            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          })
        },
      })
    },


    gerarSeparacao(){
      console.log('gerarSeparacao')

      const idsAtualizar = this.dataGrid.getSelectedRowKeys()

      console.log('idsAtualizar')
      console.log(idsAtualizar)
      console.log(idsAtualizar.length)



      if (idsAtualizar.length === 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Nenhum movimento foi selecionado, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })
      } else {

        this.dataGrid.clearSelection()

        Swal.fire({
          position: "center",
          icon: "question",
          title: "Gerar Ordem de Separação (Movimentos " + idsAtualizar + ")",
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,

        }).then(result => {
          if (result.value) {
            this.updating = true
            console.log('vai Atualizar')

            api.get(`${getBaseUrl()}api/movsgeraos`,{
              params: {
                'ids': idsAtualizar
              }
            }).then(response => {
              console.log('response.data')
              console.log(response)



              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Movimento(s) processado(s) com sucesso!",
                text: response.data,
                showConfirmButton: false,
                timer: 3500
              }).then(() => {

                //this.refeFormTable()
                //location.reload()

                //



              })



              this.updating = false
            })
          }
        })
      }
    },

    abrirMovStatus(){
      console.log('abrirMovStatus')
      this.$router.push(`/movimentos/liststatus`)

    },


    mudouExib(){
      console.log('mudouExib')
      if (!this.updating)
        this.atualizaDataList()
    },



    novoInvent(){
      console.log('novoInvent')
      this.$router.push(`/movinvent/editar/0`)
    },

    onRowDblClick(row) {
      console.log('onRowDblClick')
      let idData = row.key
      console.log(idData)
      this.$router.push(`/movinvent/editar/${idData}`)
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "movinvent_status") {

          // console.log('onCellPrepared')
          // console.log(e.data.movinvent_status)
          const valStatus = e.data.movinvent_status

          let corStatus = 'rgba(78,59,0,0.5)'

          switch (valStatus) {
            case 'EL':
              corStatus = 'rgba(78,59,0,0.5)'
              break
            case 'CF':
              corStatus = 'rgba(0,58,78,0.5)'
              break
            case 'ENP':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'ECR':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'EAT':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'NED':
              corStatus = 'rgba(146,73,0,0.5)'
              break
            case 'NEF':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'SCT':
              corStatus = 'rgba(146,111,0,0.5)'
              break
            case 'CCT':
              corStatus = 'rgba(0,58,78,0.5)'
              break
          }



          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;

        }
      }
    },

    // atualizaDataList(){
    //   console.log('atualizaDataList')
    //   this.updating = true
    //
    //   console.log(this.dtIniFiltro)
    //   console.log(this.dtFimFiltro)
    //
    //   api.get(`${getBaseUrl()}api/movsnova`,{
    //     params: {
    //       'di': this.dtIniFiltro,
    //       'df': this.dtFimFiltro,
    //       'ee': this.exibEmit,
    //       'ed': this.exibDest,
    //       'ea': this.exibAmbos
    //     }
    //   }).then(response => {
    //     console.log('response.data')
    //     console.log(response)
    //
    //     this.dataList = new ArrayStore({
    //       key: 'movinvent_id',
    //       data: response.data[0],
    //     })
    //     this.totalList = response.data[1]
    //
    //     this.updating = false
    //     const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
    //     const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')
    //
    //     this.title = `(${this.totalList}) Inventários: ${dtIniFormated} - ${dtFimFormated}`
    //   })
    // },

    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    nomeStatus(e) {

      switch (e.value) {

        case 'EL':
          return 'Elaboração (EL)'
        case 'FE':
          return 'Fechado (FE)'

          // case 'SCT':
          //   return 'Sem CTe'

          // case 'NEP':
          //   return 'Dentro do Prazo (Não Entregue)'
          // case 'NEF':
          //   return 'Fora do Prazo (Não Entregue)'

      }

      return e.value
    },

  },



};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div>

      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="increaselinespacing"
              hint="Gerar Separação"
              :on-click="gerarSeparacao"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="plus"
              hint="Importar arquivo de movimento"
              text="Novo Inventário"
              :on-click="novoInvent"/>
        </DxItem>




      </DxToolbar>

    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>


    <div class="mt-2" v-if="!updating">



      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />


        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strMovInventList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />





          <DxColumn
              data-field="movinvent_status"
              caption="Status"
              alignment="center"
              data-type="text"
              :customize-text="nomeStatus"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="movinvent_id"
              sort-order="desc"
              caption="ID"
              data-type="number"
              alignment="right"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="movinvent_dtemissao"
              caption="Emissão"
              alignment="right"
              data-type="datetime"
              format="dd/MM/yyyy"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="empresa_nome"
            caption="Empresa"
            alignment="right"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="movinvent_codigo"
              caption="NF"
              alignment="right"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="movinvent_valorliq"
              caption="Valor"
              alignment="right"
              :format="formatDecimal"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true" />




        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>


      </DxDataGrid>


    </div>


  </Layout>
</template>
